import { useEffect } from 'react'
import Close from '../../assets/Close.svg';

import './Modal.scss';

interface Props {
    id?: string;
    rtl?: boolean;
    handleHeaderCancel?: () => void;
    children: any;
    close?: boolean;
    contentClassName?: string;
    className?: string;
}

function Modal({ rtl, id, handleHeaderCancel, children, close = true, contentClassName, className }: Props) {

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        }
    }, []);

    return (
        <div className={rtl ? `CC__ModalContainer CC__ModalRight` : `CC__ModalContainer`}>
            <div className='CC__Fallback'></div>
            <div className={`CC__Modal ${className}`} id={id}>
                <div className={`CC__ModalContent ${contentClassName}`}>
                    {close && <div className='CC__header' onClick={handleHeaderCancel}>
                        <div></div>
                        <img src={Close} alt='Close' className='CC__Close' />
                    </div>}
                    {children}
                </div>

            </div>
        </div>
    )
}

export default Modal